import { Injectable, InjectionToken } from '@angular/core';

import { SfccGatedConnectorService } from './sfcc-gated-connector.service';
import { SfccGenericConnectorService } from './sfcc-generic-connector.service';

@Injectable({
    providedIn: 'root',
})
export class SfccConnectorFactoryService {
    static SFCC_GATED = new InjectionToken<SfccGatedConnectorService>('gated');
    static SFCC_GENERIC = new InjectionToken<SfccGenericConnectorService>('generic');

    constructor() {}

    getServiceToken(mode: 'gated' | 'generic'): InjectionToken<any> {
        switch (mode) {
            case 'gated':
                return SfccConnectorFactoryService.SFCC_GATED;
            case 'generic':
                return SfccConnectorFactoryService.SFCC_GENERIC;
        }
    }
}
